import { COLORS } from 'src/theme/palette';
import { SxStyles } from 'src/types/theme';

const styles: SxStyles = {
  wrapper: {
    width: '520px',
    padding: '24px',
  },
  title: {
    marginBottom: '24px',
  },
  identifier: {
    display: 'flex',
    alignItems: 'center',
    minWidth: 0,
    marginBottom: '16px',
  },
  identifierText: {
    fontWeight: 600,
    color: COLORS.black100,
    whiteSpace: 'nowrap',
    flexShrink: 0,
  },
  identifierSeparator: {
    fontWeight: 600,
    color: COLORS.black100,
    marginX: '6px',
    flexShrink: 0,
  },
  identifierEmail: {
    fontWeight: 600,
    color: COLORS.black100,
    minWidth: 0,
    flex: '1 1 auto',
  },
  buttons: {
    marginTop: '24px',
    display: 'flex',
    gap: '10px',
  },
  button: {
    padding: '7px 48px',
  },
  cancelButton: {
    color: COLORS.black80,
    borderColor: COLORS.black20,
    '&:hover, &:focus': {
      borderColor: COLORS.black20,
    },
  },
};

export default styles;
